import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shown && _vm.seminars.length > 1)?_c('div',{staticClass:"d-flex px-4"},[_c(VSpacer),_c(VSelect,{staticStyle:{"max-width":"200px"},attrs:{"items":_vm.items,"value":_vm.selectedId,"placeholder":"Choose seminar","hide-details":""},on:{"change":_vm.select}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }